import React, { Component } from "react";
import { connect } from "react-redux";
import $ from "jquery";
import { ApiClient } from "../../libs/apiClient/ApiClient";
import '../../css/responsive.css';
let apiClient = ApiClient.getInstance();
// addPartnerToRoute
// deleteRoutePartner
// saveRoute
// saveUpdatedRoute
// deleteRoute

class RoutesModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editMode: false,
            sellers: [],
            unassignedPartners: [],
            auxModel: {},
        }
    }

    async componentDidMount() {
        const { enableSpinner, showAlert } = this.props;
        enableSpinner(true);
        let sellersResponseApi = await apiClient.GetSellers();
        let partnersResponseApi = await apiClient.getUnassignedPartners();
        enableSpinner(false);

        if (!sellersResponseApi.status || !partnersResponseApi.status) {
            showAlert({ type: "warning", message: "Ocurrió un error al cargar la información, cierre e intente nuevamente", timeOut: 5000 });
        }

        await this.setState({
            sellers: sellersResponseApi.data || [],
            unassignedPartners: partnersResponseApi.data || [],
        })
    }

    closeModal = async () => {
        $("#RoutesModal").modal("hide");
    }

    editMode = async () => {
        const auxModel = JSON.parse(JSON.stringify(this.props.routeDoc));
        await this.setState({ editMode: true, auxModel });
    }
    

    searchPartners = async (search) => {
        await this.setState({ lastSearch: search });
        let partnersResponseApi = await apiClient.getUnassignedPartners(search);

        if (this.state.lastSearch === search) {
            await this.setState({ unassignedPartners: partnersResponseApi?.data || [] })
        }
    }
    
    deleteRoutePartner = (index) => {
        const { routeDoc } = this.props;
        let newRouteDoc = JSON.parse(JSON.stringify(routeDoc));
        newRouteDoc.RoutesLines.splice(index, 1);
        this.updateModelField("RoutesLines", newRouteDoc.RoutesLines);
    }

    cancelEditMode = async () => {
        await this.props.updateModel(this.state.auxModel);
        await this.setState({ editMode: false, auxModel: {} });
    }

    updateModelField = async (field, value) => {
        const { action } = this.props
        const { editMode } = this.state;
        if (action === 2 && !editMode) return;

        let auxModel = JSON.parse(JSON.stringify(this.props.routeDoc));
        auxModel[field] = value;
        await this.props.updateModel(auxModel);
    }

    renderParnerAdded = (partner, index) => {
        const { action } = this.props
        const { editMode } = this.state;

        return (
            <div className="m-2 p-2 border rounded" key={`partnerAdded-${index}`}>
                {!(action === 2 && !editMode) &&
                    <button
                        type="button"
                        className="btn btn-outline-danger float-right mt-1 ml-2"
                        onClick={() => this.deleteRoutePartner(index)} >
                        <i className="fa fa-trash" />
                    </button>
                }
                <div className="d-flex" style={{ cursor: "pointer", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    <div className="avatar flex-shrink-0 m-2 mt-3" style={{ maxHeight: "25px", maxWidth: "25px" }}>
                        <i className="fa fa-user"/>
                    </div>
                    <div>
                        <span className="text-muted ruta"> {`Latitud: ${partner.U_FMB_GPSLat}  Longitud: ${partner.U_FMB_GPSLon}`} </span> <br/>
                        <span className="ruta"> {partner.CardCode} </span>
                    </div>
                </div>
            </div>
        );
    }

    renderUnassignedPartner = (partner, index) => {
        const { action, addPartnerToRoute } = this.props
        const { editMode } = this.state;

        return (
            <div className="m-2 p-2 border rounded" key={`partnerAdded-${index}`}>
                {!(action === 2 && !editMode) &&
                    <button
                        type="button"
                        className="btn btn-outline-success float-right mt-1 ml-2"
                        onClick={() => addPartnerToRoute(partner)}>
                        <i className="fa fa-plus" />
                    </button>
                }
                <div className="d-flex" style={{ cursor: "pointer", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    <div className="avatar flex-shrink-0 m-2 mt-3" style={{ maxHeight: "25px", maxWidth: "25px" }}>
                        <i className="fa fa-user"/>
                    </div>
                    <div>
                        <span className="text-muted ruta"> {partner.CardName} </span> <br/>
                        <span className="ruta"> {partner.CardCode} </span>
                    </div>
                </div>
            </div>
        );
    }

    callActionAndClose = async (action) => {
        await action();
        this.closeModal();
    }

    render() {
        const { action, routeDoc, saveRoute, saveUpdatedRoute, deleteRoute } = this.props
        const { editMode, sellers, unassignedPartners } = this.state;

        const title = action === 1 ? "Nueva ruta" : `Detalles de ruta ${editMode ? "(Modod edición)" : ""}`;

        return (
            <>
                <div className="modal fade bd-example-modal-xl modal-open scroll" data-backdrop="false" data-keyboard="false" id="RoutesModal" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header text-white" style={{ background: "#343a40" }}>
                                <h5 className="modal-title"> {title} </h5>
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                            <div className="row">
                                <div className="col-12 col-lg-8">
                                    {(action === 2 && !editMode) &&
                                        <button type="button" className="btn btn-outline-dark border-0 mb-2 btn-editar" onClick={this.editMode}> <i className="fas fa-edit me-2"/> Editar </button>
                                    }
                                    <div className="row">
                                        <div className="col-12 col-sm-6">
                                            <div className="input-group mb-3">
                                                    <label className="input-group-text font-weight-bold ruta" htmlFor="txtRouteCode"> Código </label>
                                                <input
                                                    id="txtRouteCode"
                                                    className="form-control"
                                                    placeholder="Código"
                                                    value={routeDoc?.Code || ""}
                                                    disabled={action === 2}
                                                    onChange={({ target: { value } }) => this.updateModelField("Code", value)} />
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="input-group mb-3">
                                                    <label className="input-group-text fw-bold ruta" htmlFor="txtRouteName">Nombre</label>
                                                <input
                                                    id="txtRouteName"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Nombre"
                                                    value={routeDoc?.Name || ""}
                                                    disabled={action === 2 && !editMode}
                                                    onChange={({ target: { value } }) => this.updateModelField("Name", value)} />
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="input-group mb-3">
                                                <label className="input-group-text fw-bold ruta" htmlFor="txtRouteSeller">Vendedor</label>
                                                <select
                                                    id="txtRouteSeller"
                                                    className="form-control"
                                                    value={routeDoc?.SlpCode || ""}
                                                    disabled={action === 2 && !editMode}
                                                    onChange={({ target: { value } }) => this.updateModelField("SlpCode", value)} >
                                                    <option>Seleccionar</option>
                                                    {sellers.length  && sellers.map((seller, index) => <option key={index} value={seller.salesPrson}> {seller.firstName} {seller.lastName} </option>)}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="input-group mb-3">
                                                <span className="input-group-text font-weight-bold">
                                                    <input
                                                        id="cbRouteActive"
                                                        style={{scale: "1.5"}}
                                                        type="checkbox"
                                                        checked={routeDoc?.IsActive}
                                                        disabled={action === 2 && !editMode}
                                                        onChange={() => this.updateModelField("IsActive", !routeDoc?.IsActive)} />
                                                </span>
                                                <label className="form-control" htmlFor="cbRouteActive">Activa</label>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="input-group mb-3">
                                                    <span className="input-group-text font-weight-bold ruta"> Comentarios </span>
                                                <textarea
                                                    className="form-control"
                                                    id="txtRoutecomments"
                                                    placeholder="250 caracteres máximo"
                                                    maxLength={254}
                                                    value={routeDoc?.Comment || ""}
                                                    disabled={action === 2 && !editMode}
                                                    onChange={({ target: { value } }) => this.updateModelField("Comment", value)} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card" style={{ cursor: "auto" }}>
                                        <div className="card-header">
                                            <span className="card-title my-0 ruta"> Clientes agregados </span>
                                        </div>
                                        <div className="card-body p-0" style={{ minHeight: 100, maxHeight: 500, overflow: "auto" }}>
                                            {routeDoc && routeDoc.RoutesLines.length > 0 &&
                                                routeDoc.RoutesLines.map(this.renderParnerAdded)
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4">
                                    <div className="card" style={{ cursor: "auto", minHeight: 300, maxHeight: 600 }}>
                                        <div className="card-header">
                                            <span className="card-title my-0 ruta"> Lista de clientes </span>
                                        </div>
                                        <div className="card-body p-0" style={{ overflow: "auto" }}>
                                            {!(action === 2 && !editMode) && <input className="w-100 border-start-0 border-top-0 border-end-0 p-2" placeholder="Buscar" onChange={({target: { value }}) => this.searchPartners(value)}/>}
                                            {unassignedPartners && unassignedPartners.map(this.renderUnassignedPartner)}
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer flex-wrap gap-2">
                                {action === 1 ?
                                    <button type="button" className="btn btn-warning" onClick={() => this.callActionAndClose(saveRoute)}> Crear </button>
                                    : (editMode &&  <>
                                        <button type="button" className="btn btn-danger" onClick={() => this.callActionAndClose(deleteRoute)}> Eliminar </button>
                                        <button type="button" className="btn btn-warning" onClick={() => this.callActionAndClose(saveUpdatedRoute)}> Guardar </button>
                                        </>)
                                }
                                {(action === 2 && editMode) ?
                                    <button type="button" className="btn botonCerrar text-white" onClick={this.cancelEditMode}> Cancelar </button>
                                    :  <button type="button" className="btn botonCerrar text-white" onClick={this.closeModal}> Cerrar </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = store => {
    return {
        sessionReducer: store.SessionReducer,
        configReducer: store.ConfigReducer,
        notificationReducer: store.NotificationReducer,
    };
};

export default connect( mapStateToProps )(RoutesModal);